import { useMemo } from 'react'
import type { Trade } from '../types/trade'
import DashboardWidgetTitle from './DashboardWidgetTitle'

interface DashboardWidgetOpenPositionsProps {
  trades: Trade[]
}

const cardClass =
  'h-full w-full dashboard-card p-3 md:p-4 flex flex-col justify-center'

export default function DashboardWidgetOpenPositions({ trades }: DashboardWidgetOpenPositionsProps) {
  const openTrades = useMemo(() => trades.filter((trade) => !trade.exit_date), [trades])

  return (
    <div className={cardClass}>
      {/* Mobile: başlık ve değer yan yana */}
      <div className="flex md:hidden flex-row items-center justify-between gap-2 py-0.5">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wider truncate shrink-0">
          <DashboardWidgetTitle widgetId="openPositions" />
        </p>
        <p className="text-base font-bold text-gray-900 shrink-0">{openTrades.length}</p>
      </div>
      {/* Desktop: üstte başlık, altta değer */}
      <div className="hidden md:block">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
          <DashboardWidgetTitle widgetId="openPositions" />
        </p>
        <p className="text-xl md:text-2xl font-bold text-gray-900">{openTrades.length}</p>
      </div>
    </div>
  )
}
